var moment = require('moment');
var CategoryAPI = require('../../../../common/api').Category;
var FunderAPI = require('../../../../common/api').Funder;

module.exports = function ($scope, reportFields) {
  $scope.dict = {};
  $scope.reportFields = reportFields;

  $scope.close = function () {
    var action = 'cancel';
    $scope.closeThisDialog({ action: action, value: $scope.dict });
  }

  $scope.confirm = function () {
    var action = 'confirm';
    $scope.closeThisDialog({ action: action, value: $scope.dict });
  }

  $scope.addParam = function (field) {
    $scope.dict[field.key] = field.value;
  }
  
  $scope.init = function () {
    CategoryAPI.GetTopLevelCategories().then(function (results) {
      $scope.categories = results.map(function (c) {
        c.id = c.id.toString()
        return c
      });
      
      $scope.categories.unshift({id:null, ccName:"All"});

      $scope.reportFields.forEach(function(item) {
        if(item.reportFieldType == 1) {
          item.value = null;
          $scope.addParam(item);
        } else if(item.reportFieldType == 2) {
          item.value = "";
          $scope.addParam(item);
        } else if(item.reportFieldType == 3) {
          item.value = "";
          $scope.addParam(item);
        }
      });
    });

    FunderAPI.GetCurrentFunder("FunderDetailsView").then(function (funder) {

      CategoryAPI.GetByFunderSchemes(funder.id).then(function(results) {
      
        $scope.schemes = results.map(function(c) {
          c.id = c.id.toString();
          return c;
        });
      
        $scope.schemes.unshift({ id: null, title: "All" });
  
        $scope.reportFields.forEach(function(item) {
          if (item.reportFieldType == 7) {
            item.value = null;
            $scope.addParam(item);
          }
        });
        
        CategoryAPI.GetByFunderGrantRounds(funder.id).then(function(results) {
          $scope.grantRounds = results.map(function(c) {
            c.id = c.id.toString();
            return c;
          });
          
          $scope.grantRounds.unshift({ id: null, name: "All" });
    
          $scope.reportFields.forEach(function(item) {
            if (item.reportFieldType == 8) {
              item.value = null;
              $scope.addParam(item);
            }
          });
        });
      });
      
    } );
		
		
		
  }
  $scope.init();
}
